import Modal from './Modal';
import { ReactNode } from 'react';
import { Flexbox, Text } from '@morressier/ts';
import styled from 'styled-components';

import Button from '../Button';
import { IButton } from '../Button/Button';
import { ExitContainer } from '../ExitModal';
const Header = styled.div`
  padding: 1rem 2rem;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.25);
`;

export const Footer = styled.div`
  padding: 1rem 2rem;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.25);
`;

const Content = styled.div`
  height: 100%;
  overflow-y: auto;
  padding: 32px;
  background-color: var(--color-mono-99);
`;

export const ActionModalContainer = styled(Flexbox)<{
  showExitContainer: boolean;
}>`
  height: 100%;
  display: ${({ showExitContainer }) =>
    !showExitContainer ? 'block' : 'none'};
`;

const Container = styled(Flexbox)`
  height: 100%;
`;

const ExitButton = styled.button`
  color: var(--color-red-50);
  border: none;
  padding: 0;
  background: none;
  border-radius: 0.25rem;
  font-size: var(--fontSizes-normal);
  &:hover {
    color: var(--color-red-30);
  }
  cursor: pointer;
`;

const PrimaryButton = styled(Button)`
  margin-left: 0.5rem;
`;

interface IModalProps extends IActionModalContentProps {
  isOpen: boolean;
  showExitContainer: boolean;
  onDismiss?: () => void;
  onConfirmExitAction: () => void;
  onCancelExitAction: () => void;
}

interface IActionModalContentProps {
  children?: ReactNode;
  title?: string;
  primaryAction?: IActionButton;
  secondaryAction?: IActionButton;
  cautionaryAction?: IActionButton;
}

export interface IActionButton extends Omit<IButton, 'color'> {
  title: string;
}

export const ActionModalContent = (props: IActionModalContentProps) => {
  const { title, primaryAction, secondaryAction, cautionaryAction, children } =
    props;
  return (
    <Container flexDirection="column">
      <Header>
        <Text size="h4_new" fontWeight="medium">
          {title}
        </Text>
      </Header>
      <Content>{children}</Content>
      <Footer>
        <Flexbox justifyContent="space-between">
          {cautionaryAction && (
            <ExitButton {...cautionaryAction}>
              {cautionaryAction.title}
            </ExitButton>
          )}
          <Flexbox>
            {secondaryAction && (
              <Button color="secondary" {...secondaryAction}>
                {secondaryAction.title}
              </Button>
            )}
            {primaryAction && (
              <PrimaryButton color="primary" {...primaryAction}>
                {primaryAction.title}
              </PrimaryButton>
            )}
          </Flexbox>
        </Flexbox>
      </Footer>
    </Container>
  );
};

const ActionModal = (props: IModalProps) => {
  const {
    isOpen,
    onDismiss,
    title,
    primaryAction,
    secondaryAction,
    cautionaryAction,
    children,
    onConfirmExitAction,
    onCancelExitAction,
    showExitContainer
  } = props;
  return (
    <Modal isOpen={isOpen} onDismiss={onDismiss}>
      <ActionModalContainer showExitContainer={showExitContainer}>
        <ActionModalContent
          title={title}
          primaryAction={primaryAction}
          secondaryAction={secondaryAction}
          cautionaryAction={cautionaryAction}
        >
          {children}
        </ActionModalContent>
      </ActionModalContainer>
      <ExitContainer
        showExitContainer={showExitContainer}
        onCancel={onCancelExitAction}
        onConfirm={onConfirmExitAction}
      />
    </Modal>
  );
};
export default ActionModal;
